import isEmpty from "lodash.isempty";

export const SESSION_NAME = "Cart";

const initialState = {};

const update = (state) =>
    localStorage.setItem(SESSION_NAME, JSON.stringify(state));

const clear = () => {
    localStorage.getItem(SESSION_NAME);
    localStorage.clear();
};

const get = () => {
    const data = localStorage.getItem(SESSION_NAME);
    if (data && data !== "undefined") {
        try {
            const cart = JSON.parse(data);
            if (cart.slot_valid_until && cart.slot_valid_until) {
                const clearTime =
                    new Date(cart.slot_valid_until).getTime() + 60 * 60 * 1000;
                const currentTime = new Date().getTime();
                if (currentTime > clearTime) {
                    return null;
                }
            }
            return cart;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error parsing cart session data:", error);
        }
    }
    return null; // return null if data is not available or not valid JSON
};

const isSet = () => {
    try {
        const value = get();
        return !isEmpty(value) && !!value;
    } catch (error) {
        return false;
    }
};

const log = () => {
    console.log(SESSION_NAME, { g: get(), s: isSet() });
};

export default { initialState, update, get, clear, isSet, log };
